import React from 'react'
import WalletParent from '../../page-components/Wallet/WalletParent'
function WalletMain() {
  return (
<WalletParent />
  )
}

export default WalletMain